<template>
    <div class="tw-p-2 tw-bg-white tw-w-full tw-border tw-border-solid tw-flex tw-items-center tw-gap-2 tw-border-s-0">
        <router-link :to="{ name: 'pages.dashboard.admin' }"
            class="tw-text-gray-400 tw-duration-200 hover:tw-text-gray-700 tw-text-xl tw-flex tw-items-center tw-gap-2">
            <icon icon="solar:home-smile-bold-duotone" />
            <span class="tw-text-sm">{{
                $t("dashboard.sidebar.dashboard")
            }}</span>
        </router-link>
        <span class="tw-text-gray-300">/</span>
        <button disabled class="tw-text-primary-500 tw-text-xl tw-flex tw-items-center tw-gap-2">
            <span class="tw-text-sm">{{ $t("dashboard.sidebar.orders") }}</span>
        </button>
    </div>
    <div class="tw-p-2">
        <div
            class="tw-h-full tw-w-full tw-p-4 tw-bg-white tw-rounded tw-border tw-border-b-2 tw-min-h-[calc(100dvh-125px)]">
            <div class="tw-justify-between tw-flex tw-items-center tw-h-[40px] tw-gap-2">

                <div class="tw-flex tw-items-center tw-gap-2">
                    <div class="tw-flex tw-items-center">
                        <FormField v-model="search" @keyup.enter="onSearch"
                            placeholder="Order ID, Code..." type="text" :hide-errors="true" :hide-label="true"
                            class="tw-min-w-[120px]  ltr:!tw-rounded-none tw-peer"
                            input-class="
                            ltr:tw-rounded-e-none 
                            ltr:tw-border-e-0 
                            rtl:!tw-border-e-0 
                            rtl:tw-rounded-s 
                            rtl:tw-rounded-tl-none
                            rtl:tw-rounded-bl-none
                            rtl:!tw-border-e-none 
                            rtl:tw-rounded-s-none " />
                            <select @change="onPerPageChange" v-model="options.per_page" class="tw-w-[40px] tw-text-sm tw-outline-none peer-focus-within:tw-border-y-primary-500 tw-border-e-0 tw-text-center tw-h-[40px] tw-border tw-border-solid tw-border-gray-200 tw-duration-200">
                            <option v-for="item in [5, 10, 20, 50, 75, 100]" :key="item" :value="item" class="tw-px-2">{{ item }}</option>
                            </select>
                        <a-button @click="onSearch"
                            class=" tw-h-[40px] !tw-rounded-s-none tw-border-s  !tw-border-b peer-focus-within:tw-border-y-primary-500 peer-focus-within:tw-border-e-primary-500 active:!tw-translate-y-0"
                            icon="clarity:search-line" intent="icon"></a-button>

                    </div>
                    
                    <a-button @click="visible.filters = !visible.filters" intent="icon" class="!tw-border-b"
                        icon="solar:filter-bold-duotone"></a-button>
                    <a-button @click="onFollowup" class="tw-duration-200 !tw-border-b"
                        intent="icon"
                        :class="active.followup ? '!tw-border-primary-500 !tw-text-primary-500' : 'tw-bg-white tw-text-gray-500'"
                        icon="solar:smartphone-update-bold-duotone"></a-button>
                    <a-button @click="showColumnSelector = true" intent="icon" class="!tw-border-b tw-relative group" icon="solar:settings-bold-duotone">
                        <div class="tw-absolute tw-bottom-full tw-left-1/2 tw-transform -tw-translate-x-1/2 tw-mb-2 tw-w-max tw-opacity-0 tw-invisible group-hover:tw-opacity-100 group-hover:tw-visible tw-transition-all tw-duration-200">
                            <div class="tw-bg-gray-800 tw-text-white tw-text-xs tw-px-2 tw-py-1 tw-rounded">
                                {{ $t('common.column_visibility') }}
                            </div>
                        </div>
                    </a-button>
                </div>
                <CreateOrderPopup @created="onCreated" />
            </div>
            <OrderFilterWrapper v-model:filters="filters" v-model:visible="visible.filters" @filter="onFilter" />
            <div class="tw-mt-5 tw-roundedx tw-overflow-hiddenx">
                <OrderTable :loading="loading" :items="orders" :options="options" 
                    @next="onNext"
                    @previous="onPrevious" 
                    :show-column-selector="showColumnSelector" 
                    @update:show-column-selector="showColumnSelector = $event"
                    :sort-field="sortField"
                    :sort-direction="sortDirection"
                    @sort="handleSort" />
            </div>
        </div>

        
    </div>
</template>

<script setup>
import { ref, provide, watch } from "vue";
import { paginate } from "@/api/orders";
import FormField from "@/components/form/FormField";
import OrderTable from "@/views/admin/orders/partials/table/OrderTable";
import CreateOrderPopup from '@/components/orders/CreateOrderPopup'
import { useStateStore } from "@/stores/app/state";
import OrderFilterWrapper from '@/components/filters/order/list/OrderFilterWrapper'
import { getQueryParams } from "@/utils/methods";

const stateStore = useStateStore();
const urlParams = getQueryParams(window.location.href);
const search = ref(urlParams.search || "");
const searchBy = ref(urlParams.search_by || "");
const loading = ref(true);
const orders = ref([]);
const options = ref({
    per_page: 10,
});
const filters = ref(urlParams);
const showColumnSelector = ref(false);

// Add sort state
const sortField = ref('');
const sortDirection = ref('asc');

console.log(filters.value);


const visible = ref({
    filters: false
})

const active = ref({
    followup: false
})

async function fetchOrders(page = 1) {
    orders.value = [];
    loading.value = true;
    await paginate({ 
        per_page: options.value.per_page, 
        page, 
        search: search.value, 
        search_by: searchBy.value,
        filters: filters.value, 
        is_followup: active.value.followup,
        sort_field: sortField.value,
        sort_direction: sortDirection.value
    })
        .then(
            ({ data }) => {
                const { data: items, ...ops } = data.data;
                options.value = ops
                orders.value = items;
                stateStore.setCountOrders(options.value.total);
            },
            (error) => {
                console.log(error);
            }
        );
    loading.value = false;
}

// Handle sort event from OrderTable
const handleSort = ({ field, direction }) => {
    sortField.value = field;
    sortDirection.value = direction;
    fetchOrders(1);
}

watch(
    () => options.value.per_page,
    () => {
        fetchOrders();
    }
)

const onUpdate = (order) => {
    orders.value = orders.value.map((item) => item.id == order.id ? order : item);
}

const onSearch = () => {
    fetchOrders(1)
}

const onFilter = () => {
    fetchOrders(1)
}

const onPerPageChange = () => {
    fetchOrders()
}

const onFollowup = () => {
    active.value.followup = !active.value.followup
    fetchOrders(1)
}


const onNext = () => {
    fetchOrders(options.value.current_page + 1)
}

const onPrevious = () => {
    fetchOrders(options.value.current_page - 1)
}

const onCreated = order => {
    orders.value.unshift(order);
}

provide("updateOrder", onUpdate);
provide("active", active);

fetchOrders();
</script>

<style></style>
